import React from 'react'

import { Card } from 'components'
import { COLORS, SPACING } from 'utils'

import EditNewDocumentation from './components/EditNewDocumentation'
interface INewDocumentation {
  documentoCaixaId: number
  handleChange: (_x: any, _newValue: number) => void
}

const EditDocumentation: React.FC<INewDocumentation> = ({
  documentoCaixaId,
  handleChange
}) => {
  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <EditNewDocumentation
        documentoCaixaId={documentoCaixaId}
        handleChange={handleChange}
      />
    </Card>
  )
}

export default EditDocumentation
